module.exports = __webpack_public_path__ + "img/totalDistance.6b64c910.png";